import React, { useState, useEffect, useCallback } from 'react';
import Navbar from '../components/Navbar';
import { formatCurrency } from '../utils/formatters';
import './CadastroFuncionarios.css';

const CadastroFuncionarios = () => {
    const [employees, setEmployees] = useState([]);
    const [search, setSearch] = useState('');
    const [criteria, setCriteria] = useState({
        Nome: true,
        Função: false,
        Título: false,
        Endereço: false,
        CPF_RG: false,
        Obs: false,
        Email: false
    });
    const [currentEmpId, setCurrentEmpId] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        PrimeiroNome: '',
        Sobrenome: '',
        Titulo: '',
        Funcao: '',
        RG: '',
        CPF: '',
        Endereco: '',
        TelefoneResidencial: '',
        TelefoneComercial: '',
        Ramal: '',
        NomeCorreioEletronico: '',
        DadosPagamento: '',
        Observacoes: '',
        Foto: '',
        DocFotos: '',
        FotoRG: '',
        FotoCPF: ''
    });
    const [financeData, setFinanceData] = useState(null);
    const [financeLoading, setFinanceLoading] = useState(false);
    const [gallery, setGallery] = useState([]);
    const [galleryLoading, setGalleryLoading] = useState(false);
    const [showQuickFinance, setShowQuickFinance] = useState(false);
    const [quickFinanceData, setQuickFinanceData] = useState({
        Tipo: 'Pagar',
        Descricao: '',
        Valor: '',
        DataVencimento: new Date().toISOString().split('T')[0],
        Status: 'Pendente'
    });
    const [financeFilter, setFinanceFilter] = useState({
        startDate: '',
        endDate: ''
    });

    const fetchEmployees = useCallback(async (searchTerm = '') => {
        setLoading(true);
        try {
            const activeFields = Object.keys(criteria).filter(key => criteria[key]).join(',');
            let url = '/api/funcionarios';
            const params = new URLSearchParams();
            if (searchTerm) params.append('search', searchTerm);
            if (activeFields) params.append('fields', activeFields);

            if (params.toString()) {
                url += `?${params.toString()}`;
            }

            const res = await fetch(url, { credentials: 'include' });
            const data = await res.json();
            setEmployees(data);
        } catch (error) {
            console.error('Erro ao buscar funcionários:', error);
        } finally {
            setLoading(false);
        }
    }, [criteria]);

    useEffect(() => {
        const fetchUser = async () => {
            const res = await fetch('/api/auth/me', { credentials: 'include' });
            if (res.ok) {
                const data = await res.json();
                setUser(data.user);
            }
        };
        fetchUser();
        fetchEmployees();
    }, [fetchEmployees]);

    const handleSearch = (e) => {
        setSearch(e.target.value);
    };

    const triggerSearch = () => {
        fetchEmployees(search);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            triggerSearch();
        }
    };

    const toggleCriteria = (field) => {
        setCriteria(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const selectEmployee = (id) => {
        const emp = employees.find(e => e.ID === id);
        if (!emp) return;
        setCurrentEmpId(id);
        setFormData({
            PrimeiroNome: emp.PrimeiroNome || '',
            Sobrenome: emp.Sobrenome || '',
            Titulo: emp.Titulo || '',
            Funcao: emp.Funcao || '',
            RG: emp.RG || '',
            CPF: emp.CPF || '',
            Endereco: emp.Endereco || '',
            TelefoneResidencial: emp.TelefoneResidencial || '',
            TelefoneComercial: emp.TelefoneComercial || '',
            Ramal: emp.Ramal || '',
            NomeCorreioEletronico: emp.NomeCorreioEletronico || '',
            DadosPagamento: emp.DadosPagamento || '',
            Observacoes: emp.Observacoes || '',
            Foto: emp.Foto || '',
            DocFotos: emp.DocFotos || '',
            FotoRG: emp.FotoRG || '',
            FotoCPF: emp.FotoCPF || ''
        });
        fetchEmployeeFinance(id);
        fetchEmployeeGallery(id);
    };

    const fetchEmployeeGallery = async (id) => {
        setGalleryLoading(true);
        try {
            const res = await fetch(`/api/funcionarios/${id}/fotos`, { credentials: 'include' });
            if (res.ok) {
                const data = await res.json();
                setGallery(Array.isArray(data) ? data : []);
            }
        } catch (error) {
            console.error('Erro ao buscar galeria:', error);
        } finally {
            setGalleryLoading(false);
        }
    };

    const fetchEmployeeFinance = async (id, filters = {}) => {
        setFinanceLoading(true);
        try {
            let url = `/api/financas/funcionario/${id}`;
            const params = new URLSearchParams();
            if (filters.startDate) params.append('startDate', filters.startDate);
            if (filters.endDate) params.append('endDate', filters.endDate);

            if (params.toString()) url += `?${params.toString()}`;

            const res = await fetch(url, { credentials: 'include' });
            if (res.ok) {
                const data = await res.json();
                setFinanceData(data);
            }
        } catch (error) {
            console.error('Erro ao buscar financeiro do funcionário:', error);
        } finally {
            setFinanceLoading(false);
        }
    };

    // Helper: Converte de DD/MM/AAAA para YYYY-MM-DD (ISO)
    const brToISO = (brDate) => {
        if (!brDate) return '';
        const parts = brDate.split('/');
        if (parts.length !== 3) return '';
        const [day, month, year] = parts;
        if (!day || !month || !year) return '';
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    // Helper: Converte de YYYY-MM-DD (ISO) para DD/MM/AAAA
    const isoToBR = (isoDate) => {
        if (!isoDate) return '';
        const simpleDate = isoDate.split('T')[0];
        const parts = simpleDate.split('-');
        if (parts.length !== 3) return '';
        const [year, month, day] = parts;
        return `${day}/${month}/${year}`;
    };

    const handlePeriodDateInput = (e, setter) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length >= 2) value = value.slice(0, 2) + '/' + value.slice(2);
        if (value.length >= 5) value = value.slice(0, 5) + '/' + value.slice(5, 9);
        setter(value);
    };

    const handleHiddenPeriodChange = (e, setter) => {
        const isoValue = e.target.value;
        if (isoValue) {
            const brValue = isoToBR(isoValue);
            setter(brValue);
        }
    };

    const handleApplyFinanceFilter = () => {
        if (!currentEmpId) return;
        const filters = {
            startDate: brToISO(financeFilter.startDate),
            endDate: brToISO(financeFilter.endDate)
        };
        fetchEmployeeFinance(currentEmpId, filters);
    };

    const handlePrintReport = () => {
        if (!financeData || !financeData.transactions) return;

        const win = window.open('', '_blank');
        const employeeName = `${formData.PrimeiroNome} ${formData.Sobrenome}`;
        const hasPhoto = formData.Foto;

        const printContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Relatório Financeiro - ${employeeName}</title>
                <style>
                    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 40px; color: #333; }
                    .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #000080; padding-bottom: 20px; margin-bottom: 30px; }
                    .logo-area img { height: 60px; }
                    .report-title { text-align: right; }
                    .report-title h1 { margin: 0; color: #000080; font-size: 1.5rem; }
                    .report-title p { margin: 5px 0 0; font-size: 0.9rem; color: #666; }
                    
                    .employee-info { display: flex; gap: 30px; margin-bottom: 30px; background: #f9f9f9; padding: 20px; border: 1px solid #ddd; }
                    .emp-photo { width: 120px; height: 140px; border: 1px solid #ccc; background: #eee; overflow: hidden; display: flex; align-items: center; justify-content: center; }
                    .emp-photo img { width: 100%; height: 100%; object-fit: cover; }
                    .emp-details { flex: 1; display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
                    .detail-item label { display: block; font-size: 0.75rem; color: #777; font-weight: bold; text-transform: uppercase; }
                    .detail-item span { font-size: 1rem; color: #000; }
                    
                    .finance-table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                    .finance-table th { background: #000080; color: #fff; padding: 10px; text-align: left; font-size: 0.9rem; }
                    .finance-table td { padding: 10px; border-bottom: 1px solid #eee; font-size: 0.85rem; }
                    .finance-table tr:nth-child(even) { background: #fcfcfc; }
                    .row-pagar { color: #8b0000; }
                    .row-receber { color: #006400; }
                    
                    .summary-box { margin-top: 30px; display: flex; justify-content: flex-end; gap: 40px; padding: 20px; border-top: 2px solid #000080; }
                    .summary-item { text-align: right; }
                    .summary-item label { display: block; font-size: 0.8rem; color: #666; font-weight: bold; }
                    .summary-item span { font-size: 1.2rem; font-weight: bold; }
                    .total-label { color: #000080; }
                    
                    .footer { margin-top: 50px; text-align: center; font-size: 0.8rem; color: #999; border-top: 1px solid #eee; padding-top: 10px; }
                    
                    @media print {
                        body { padding: 20px; }
                        .no-print { display: none; }
                    }
                </style>
            </head>
            <body>
                <div class="header">
                    <div class="logo-area">
                        <img src="/logo-ra.png" alt="RA Multi Services">
                    </div>
                    <div class="report-title">
                        <h1>Relatório Financeiro</h1>
                        <p>Gerado em: ${new Date().toLocaleDateString('pt-BR')} às ${new Date().toLocaleTimeString('pt-BR')}</p>
                        ${financeFilter.startDate || financeFilter.endDate ?
                `<p>Período: ${financeFilter.startDate || 'Início'} até ${financeFilter.endDate || 'Hoje'}</p>`
                : '<p>Período: Completo</p>'}
                    </div>
                </div>

                <div class="employee-info">
                    <div class="emp-photo">
                        ${hasPhoto ? `<img src="${formData.Foto}" alt="Foto">` : '👤'}
                    </div>
                    <div class="emp-details">
                        <div class="detail-item" style="grid-column: span 2;">
                            <label>Funcionário</label>
                            <span>${employeeName}</span>
                        </div>
                        <div class="detail-item">
                            <label>CPF</label>
                            <span>${formData.CPF || '---'}</span>
                        </div>
                        <div class="detail-item">
                            <label>RG</label>
                            <span>${formData.RG || '---'}</span>
                        </div>
                        <div class="detail-item">
                            <label>Cargo / Função</label>
                            <span>${formData.Funcao || '---'}</span>
                        </div>
                        <div class="detail-item">
                            <label>Endereço</label>
                            <span>${formData.Endereco || '---'}</span>
                        </div>
                    </div>
                </div>

                <table class="finance-table">
                    <thead>
                        <tr>
                            <th>Data Venc.</th>
                            <th>Descrição</th>
                            <th>Tipo</th>
                            <th>Valor</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${financeData.transactions.map(t => `
                            <tr>
                                <td>${isoToBR(t.DataVencimento)}</td>
                                <td>${t.Descricao}</td>
                                <td class="row-${t.Tipo.toLowerCase()}">${t.Tipo}</td>
                                <td>${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(t.Valor)}</td>
                                <td>${t.Status}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>

                <div class="summary-box">
                    <div class="summary-item">
                        <label>Total a Pagar</label>
                        <span style="color: #8b0000;">${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(financeData.summary.pagar)}</span>
                    </div>
                    <div class="summary-item">
                        <label>Total Já Pago</label>
                        <span style="color: #006400;">${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(financeData.summary.pago)}</span>
                    </div>
                </div>

                <div class="footer">
                    Este documento é uma representação digital das informações contidas no sistema RA Manager.
                </div>

                <script>
                    window.onload = function() {
                        setTimeout(() => {
                            window.print();
                            // window.close();
                        }, 500);
                    };
                </script>
            </body>
            </html>
        `;

        win.document.write(printContent);
        win.document.close();
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setFormData(prev => ({ ...prev, Foto: reader.result }));
        };
        reader.readAsDataURL(file);
    };

    const handleDocPhotoUpload = (field, e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData(prev => ({ ...prev, [field]: reader.result }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleAddGalleryPhoto = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = async () => {
            const base64 = reader.result;
            try {
                const res = await fetch(`/api/funcionarios/${currentEmpId}/fotos`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ foto: base64, comentario: '' }),
                    credentials: 'include'
                });
                if (res.ok) {
                    fetchEmployeeGallery(currentEmpId);
                }
            } catch (error) {
                console.error('Erro ao subir foto para galeria:', error);
            }
        };
        reader.readAsDataURL(file);
    };

    const handleDeleteGalleryPhoto = async (photoId) => {
        if (!window.confirm('Excluir esta foto da galeria?')) return;
        try {
            const res = await fetch(`/api/funcionarios/fotos/${photoId}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            if (res.ok) {
                fetchEmployeeGallery(currentEmpId);
            }
        } catch (error) {
            console.error('Erro ao deletar foto:', error);
        }
    };

    const handleUpdateComment = async (photoId, currentComment) => {
        const newComment = prompt('Editar legenda:', currentComment || '');
        if (newComment === null) return;
        try {
            const res = await fetch(`/api/funcionarios/fotos/${photoId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ comentario: newComment }),
                credentials: 'include'
            });
            if (res.ok) {
                fetchEmployeeGallery(currentEmpId);
            }
        } catch (error) {
            console.error('Erro ao atualizar legenda:', error);
        }
    };

    const handleSave = async (e) => {
        if (e) e.preventDefault();
        if (!currentEmpId) return;
        try {
            const res = await fetch(`/api/funcionarios/${currentEmpId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
                credentials: 'include'
            });
            if (res.ok) {
                alert('Informações do funcionário atualizadas!');
                fetchEmployees(search);
            } else {
                alert('Erro ao salvar informações.');
            }
        } catch (error) {
            console.error('Erro ao salvar:', error);
        }
    };

    const handleQuickFinanceSave = async (e) => {
        e.preventDefault();
        const emp = employees.find(e => e.ID === currentEmpId);
        if (!emp) return;
        const payload = {
            ...quickFinanceData,
            Entidade: `${emp.PrimeiroNome} ${emp.Sobrenome}`,
            IDFuncionario: currentEmpId
        };

        try {
            const res = await fetch('/api/financas', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
                credentials: 'include'
            });
            if (res.ok) {
                alert('Lançamento realizado e vinculado!');
                setShowQuickFinance(false);
                fetchEmployeeFinance(emp.ID);
                setQuickFinanceData({
                    Tipo: 'Pagar',
                    Descricao: '',
                    Valor: '',
                    DataVencimento: new Date().toISOString().split('T')[0],
                    Status: 'Pendente'
                });
            } else {
                alert('Erro ao realizar lançamento.');
            }
        } catch (error) {
            console.error('Erro ao salvar financeiro:', error);
        }
    };

    const createNewEmployee = async () => {
        try {
            const res = await fetch('/api/funcionarios', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    PrimeiroNome: 'Novo',
                    Sobrenome: 'Funcionário'
                }),
                credentials: 'include'
            });
            if (res.ok) {
                alert('Novo funcionário criado!');
                fetchEmployees(search);
            } else {
                alert('Erro ao criar funcionário.');
            }
        } catch (error) {
            console.error('Erro ao criar:', error);
        }
    };

    return (
        <div className="cadastro-funcionarios-container">
            <Navbar user={user} />

            <div className="emp-layout">
                <aside className="emp-sidebar">
                    <div className="sidebar-header">
                        <h2>Funcionários</h2>
                        <button className="btn-new-emp" onClick={createNewEmployee}>+ Novo</button>
                    </div>

                    <div className="search-box">
                        <div className="search-input-group">
                            <input
                                type="text"
                                placeholder="Pesquisar..."
                                value={search}
                                onChange={handleSearch}
                                onKeyDown={handleKeyDown}
                            />
                            <button className="btn-search-trigger" onClick={triggerSearch}>🔍</button>
                        </div>
                        <div className="search-criteria">
                            {Object.keys(criteria).map(field => (
                                <label key={field} className="criteria-chip">
                                    <input
                                        type="checkbox"
                                        checked={criteria[field]}
                                        onChange={() => toggleCriteria(field)}
                                    />
                                    <span>{field}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="emp-list">
                        {loading ? (
                            <p className="loading-text">Carregando...</p>
                        ) : (
                            employees.map((emp) => (
                                <div
                                    key={emp.ID}
                                    className={`emp-item ${currentEmpId === emp.ID ? 'active' : ''}`}
                                    onClick={() => selectEmployee(emp.ID)}
                                >
                                    <div className="emp-avatar-small">
                                        {emp.Foto ? <img src={emp.Foto} alt="" /> : <span>👤</span>}
                                    </div>
                                    <div className="emp-info-brief">
                                        <strong>{emp.PrimeiroNome} {emp.Sobrenome}</strong>
                                        <span>{emp.Funcao || emp.Titulo || 'Funcionário'}</span>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </aside>

                <main className="emp-content">
                    {currentEmpId !== null ? (
                        <form onSubmit={handleSave} className="emp-form-window">
                            <div className="win-title">
                                Ficha do Funcionário #{currentEmpId}
                            </div>

                            <div className="win-body">
                                <div className="form-section">
                                    <h3 className="section-title">Dados Pessoais</h3>
                                    <div className="form-row">
                                        <div className="form-group photo-upload">
                                            <div className="photo-preview">
                                                {formData.Foto ? <img src={formData.Foto} alt="Perfil" /> : <span>Sem Foto</span>}
                                            </div>
                                            <div className="photo-input-group">
                                                <input type="file" accept="image/*" onChange={handleFileChange} id="emp-photo-upload" style={{ display: 'none' }} />
                                                <label htmlFor="emp-photo-upload" className="btn-classic">Selecionar Foto</label>
                                                {formData.Foto && <button type="button" className="btn-classic danger" onClick={() => setFormData({ ...formData, Foto: '' })}>Remover</button>}
                                            </div>
                                        </div>
                                        <div className="form-fields-flex">
                                            <div className="form-group">
                                                <label>Primeiro Nome</label>
                                                <input type="text" name="PrimeiroNome" value={formData.PrimeiroNome} onChange={handleInputChange} />
                                            </div>
                                            <div className="form-group">
                                                <label>Sobrenome</label>
                                                <input type="text" name="Sobrenome" value={formData.Sobrenome} onChange={handleInputChange} />
                                            </div>
                                            <div className="form-group">
                                                <label>RG</label>
                                                <div style={{ display: 'flex', gap: '5px' }}>
                                                    <input type="text" name="RG" value={formData.RG} onChange={handleInputChange} style={{ flex: 1 }} />
                                                    <input type="file" id="rg-upload" style={{ display: 'none' }} onChange={(e) => handleDocPhotoUpload('FotoRG', e)} />
                                                    <label htmlFor="rg-upload" className="btn-classic" title="Subir foto do RG">📷</label>
                                                    {formData.FotoRG && (
                                                        <button type="button" className="btn-classic" onClick={() => window.open().document.write(`<img src="${formData.FotoRG}" style="max-width:100%"/>`)} title="Ver RG">👁️</button>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label>CPF</label>
                                                <div style={{ display: 'flex', gap: '5px' }}>
                                                    <input type="text" name="CPF" value={formData.CPF} onChange={handleInputChange} style={{ flex: 1 }} />
                                                    <input type="file" id="cpf-upload" style={{ display: 'none' }} onChange={(e) => handleDocPhotoUpload('FotoCPF', e)} />
                                                    <label htmlFor="cpf-upload" className="btn-classic" title="Subir foto do CPF">📷</label>
                                                    {formData.FotoCPF && (
                                                        <button type="button" className="btn-classic" onClick={() => window.open().document.write(`<img src="${formData.FotoCPF}" style="max-width:100%"/>`)} title="Ver CPF">👁️</button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {(formData.FotoRG || formData.FotoCPF) && (
                                        <div className="doc-warning-box">
                                            <small>⚠️ Fotos de documentos serão encriptadas no servidor para maior segurança.</small>
                                        </div>
                                    )}
                                </div>

                                <div className="form-section">
                                    <h3 className="section-title">Profissional & Contato</h3>
                                    <div className="form-grid">
                                        <div className="form-group">
                                            <label>Função / Cargo</label>
                                            <input type="text" name="Funcao" value={formData.Funcao} onChange={handleInputChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Endereço</label>
                                            <input type="text" name="Endereco" value={formData.Endereco} onChange={handleInputChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Telefone Comercial</label>
                                            <input type="text" name="TelefoneComercial" value={formData.TelefoneComercial} onChange={handleInputChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Outro</label>
                                            <input type="text" name="Ramal" value={formData.Ramal} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-section">
                                    <h3 className="section-title">Financeiro & Notas</h3>
                                    <div className="form-grid-2">
                                        <div className="form-group">
                                            <label>Dados de Pagamento (Banco, PIX...)</label>
                                            <textarea name="DadosPagamento" rows="3" value={formData.DadosPagamento} onChange={handleInputChange}></textarea>
                                        </div>
                                        <div className="form-group">
                                            <label>Observações</label>
                                            <textarea name="Observacoes" rows="3" value={formData.Observacoes} onChange={handleInputChange}></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-section finance-history-section">
                                    <h3 className="section-title">Histórico de Pagamentos (Vínculos)</h3>

                                    <div className="finance-filters no-print">
                                        <div className="filter-group">
                                            <label>Data Início</label>
                                            <div className="date-input-wrapper">
                                                <input
                                                    type="text"
                                                    value={financeFilter.startDate}
                                                    onChange={(e) => handlePeriodDateInput(e, (val) => setFinanceFilter({ ...financeFilter, startDate: val }))}
                                                    placeholder="DD/MM/AAAA"
                                                    maxLength="10"
                                                    className="date-input-br"
                                                />
                                                <input
                                                    type="date"
                                                    className="hidden-date-picker"
                                                    onChange={(e) => handleHiddenPeriodChange(e, (val) => setFinanceFilter({ ...financeFilter, startDate: val }))}
                                                    value={brToISO(financeFilter.startDate) || ''}
                                                />
                                                <button type="button" className="btn-calendar-trigger" onClick={(e) => e.currentTarget.previousSibling.showPicker?.() || e.currentTarget.previousSibling.click()}>📅</button>
                                            </div>
                                        </div>
                                        <div className="filter-group">
                                            <label>Data Fim</label>
                                            <div className="date-input-wrapper">
                                                <input
                                                    type="text"
                                                    value={financeFilter.endDate}
                                                    onChange={(e) => handlePeriodDateInput(e, (val) => setFinanceFilter({ ...financeFilter, endDate: val }))}
                                                    placeholder="DD/MM/AAAA"
                                                    maxLength="10"
                                                    className="date-input-br"
                                                />
                                                <input
                                                    type="date"
                                                    className="hidden-date-picker"
                                                    onChange={(e) => handleHiddenPeriodChange(e, (val) => setFinanceFilter({ ...financeFilter, endDate: val }))}
                                                    value={brToISO(financeFilter.endDate) || ''}
                                                />
                                                <button type="button" className="btn-calendar-trigger" onClick={(e) => e.currentTarget.previousSibling.showPicker?.() || e.currentTarget.previousSibling.click()}>📅</button>
                                            </div>
                                        </div>
                                        <div className="filter-actions">
                                            <button type="button" className="btn-classic" onClick={handleApplyFinanceFilter}>Filtrar</button>
                                            <button type="button" className="btn-classic" onClick={() => {
                                                setFinanceFilter({ startDate: '', endDate: '' });
                                                fetchEmployeeFinance(currentEmpId, { startDate: '', endDate: '' });
                                            }}>Limpar</button>
                                            <button type="button" className="btn-classic" onClick={handlePrintReport} title="Imprimir Relatório">🖨️ Imprimir</button>
                                        </div>
                                    </div>
                                    {financeLoading ? (
                                        <p>Carregando histórico...</p>
                                    ) : financeData ? (
                                        <div className="finance-summary-container">
                                            <div className="finance-mini-cards">
                                                <div className="mini-card unpaid">
                                                    <label>A Pagar</label>
                                                    <span>{formatCurrency(financeData.summary.pagar)}</span>
                                                </div>
                                                <div className="mini-card paid">
                                                    <label>Já Pago</label>
                                                    <span>{formatCurrency(financeData.summary.pago)}</span>
                                                </div>
                                            </div>

                                            <div className="finance-table-wrapper">
                                                <table className="mini-finance-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Data</th>
                                                            <th>Descrição</th>
                                                            <th>Valor</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {financeData.transactions.length > 0 ? (
                                                            financeData.transactions.map(t => (
                                                                <tr key={t.ID} className={t.Status === 'Concluído' ? 'row-done' : 'row-pending'}>
                                                                    <td>{new Date(t.DataVencimento).toLocaleDateString('pt-BR')}</td>
                                                                    <td>{t.Descricao}</td>
                                                                    <td>{formatCurrency(t.Valor)}</td>
                                                                    <td>{t.Status}</td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="4" style={{ textAlign: 'center' }}>Nenhum lançamento vinculado.</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                                                <button type="button" className="btn-classic primary" onClick={() => setShowQuickFinance(true)}>
                                                    + Novo Pagamento
                                                </button>
                                                <button type="button" className="btn-classic" onClick={() => window.location.href = '/financeiro'}>
                                                    Ir para o Financeiro
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <p>Selecione um funcionário para ver o financeiro.</p>
                                    )}
                                </div>

                                <div className="form-section employee-gallery-section">
                                    <h3 className="section-title">Galeria de Fotos & Documentos Extras</h3>
                                    <div className="gallery-header">
                                        <input type="file" id="gallery-add" style={{ display: 'none' }} onChange={handleAddGalleryPhoto} />
                                        <label htmlFor="gallery-add" className="btn-classic">+ Adicionar Foto</label>
                                    </div>
                                    <div className="gallery-grid">
                                        {galleryLoading ? (
                                            <p>Carregando galeria...</p>
                                        ) : (gallery || []).length > 0 ? (
                                            gallery.map(foto => (
                                                <div key={foto.ID || foto.id} className="gallery-item-card">
                                                    <div className="gallery-img-wrap" onClick={() => window.open().document.write(`<img src="${foto.FotoBase64}" style="max-width:100%"/>`)}>
                                                        <img src={foto.FotoBase64} alt="Doc" />
                                                    </div>
                                                    <div className="gallery-info">
                                                        <span className="gallery-comment" title={foto.Comentario}>{foto.Comentario || 'Sem legenda'}</span>
                                                        <div className="gallery-actions">
                                                            <button type="button" onClick={() => handleUpdateComment(foto.ID || foto.id, foto.Comentario)}>✏️</button>
                                                            <button type="button" className="danger" onClick={() => handleDeleteGalleryPhoto(foto.ID || foto.id)}>🗑️</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="gallery-empty">Nenhuma foto na galeria.</p>
                                        )}
                                    </div>
                                </div>

                                <div className="form-actions">
                                    <button type="submit" className="btn-classic primary">Salvar Alterações</button>
                                </div>
                            </div>
                        </form>
                    ) : (
                        <div className="emp-empty-state">
                            <p>Selecione um funcionário na lista à esquerda para ver os detalhes.</p>
                        </div>
                    )}
                </main>
            </div>

            {showQuickFinance && (
                <div className="modal-overlay">
                    <div className="modal-classic quick-finance-modal">
                        <div className="modal-header">
                            <span>Vincular Novo Lançamento</span>
                            <button onClick={() => setShowQuickFinance(false)}>X</button>
                        </div>
                        <form onSubmit={handleQuickFinanceSave} className="modal-body">
                            <div className="form-group">
                                <label>Tipo</label>
                                <select
                                    value={quickFinanceData.Tipo}
                                    onChange={(e) => setQuickFinanceData({ ...quickFinanceData, Tipo: e.target.value })}
                                >
                                    <option value="Pagar">A Pagar (Saída)</option>
                                    <option value="Receber">A Receber (Entrada)</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Descrição</label>
                                <input
                                    type="text"
                                    value={quickFinanceData.Descricao}
                                    onChange={(e) => setQuickFinanceData({ ...quickFinanceData, Descricao: e.target.value })}
                                    placeholder="Ex: Pagamento Quinzena"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Valor (R$)</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    value={quickFinanceData.Valor}
                                    onChange={(e) => setQuickFinanceData({ ...quickFinanceData, Valor: e.target.value })}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Vencimento</label>
                                <input
                                    type="date"
                                    value={quickFinanceData.DataVencimento}
                                    onChange={(e) => setQuickFinanceData({ ...quickFinanceData, DataVencimento: e.target.value })}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Status</label>
                                <select
                                    value={quickFinanceData.Status}
                                    onChange={(e) => setQuickFinanceData({ ...quickFinanceData, Status: e.target.value })}
                                >
                                    <option value="Pendente">Pendente</option>
                                    <option value="Concluído">Concluído (Pago)</option>
                                </select>
                            </div>
                            <div className="form-actions" style={{ marginTop: '20px' }}>
                                <button type="submit" className="btn-classic primary">Confirmar Lançamento</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CadastroFuncionarios;
